var DiagonalMovement = {
    Always: 1,
    Never: 2,
    IfAtMostOneObstacle: 3,
    OnlyWhenNoObstacles: 4
};

module.exports = DiagonalMovement;


/*****************
 ** WEBPACK FOOTER
 ** ./~/pathfinding/src/core/DiagonalMovement.js
 ** module id = 17
 ** module chunks = 0
 **/